import React__default from 'react';
import { Tabs as Tabs$1, TabList, Tab } from 'react-aria-components';
import './Tabs.scss';

const Tabs = ({ items, variant = 'default', className, onSelect, ...props }) => {
    return (React__default.createElement(Tabs$1, { className: className, ...props, "data-rev-component": 'tabs', "data-rev-variant": variant, onSelectionChange: (key) => {
            const item = items.find((item) => item.id === key);
            if (item && onSelect) {
                onSelect(item);
            }
        } },
        React__default.createElement(TabList, { className: 'tabs-list--rev' }, items.map((item) => (React__default.createElement(Tab, { className: 'tabs-tab--rev', key: item.id, id: item.id, isDisabled: item.disabled },
            React__default.createElement("span", { className: 'tabs-tab-content--rev' }, item.content)))))));
};

export { Tabs };
//# sourceMappingURL=Tabs.js.map
